// إعدادات الواجهة — عنوان الـAPI وحده، فالواجهة لا تعرف شيئاً آخر عن الخادم.
//
// ثلاث طرق للضبط، بهذا الترتيب:
//   ١) <meta name="api-base" content="https://api.example.com"> في index.html
//   ٢) localStorage.setItem('fw.apiBase', '...')  — مفيد للتجربة السريعة
//   ٣) فارغ = نفس الأصل، وهو ما يعمل خلف وكيل يمرّر /api إلى الخادم

function fromEnv(){
  // Vite يستبدل هذا وقت البناء؛ اضبط VITE_API_BASE في .env عند الحاجة
  try {
    const v = import.meta.env && import.meta.env.VITE_API_BASE;
    return v ? String(v) : null;
  } catch { return null; }
}

function fromMeta(){
  const el = document.querySelector('meta[name="api-base"]');
  const v = el && el.getAttribute('content');
  // نتجاهل القيمة النائبة حتى لا يفشل المشروع فور استنساخه بلا تعديل
  return v && !v.startsWith('__') ? v : null;
}

function fromStorage(){
  try { return localStorage.getItem('fw.apiBase'); } catch { return null; }
}

const raw = (fromEnv() || fromMeta() || fromStorage() || '').trim();

/** بلا شرطة مائلة في النهاية حتى لا تتضاعف عند الدمج. */
export const API_BASE = raw.replace(/\/+$/, '');

/** هل الـAPI على أصل مختلف عن الصفحة؟ */
export const IS_CROSS_ORIGIN = !!API_BASE && (() => {
  try { return new URL(API_BASE, location.href).origin !== location.origin; }
  catch { return false; }
})();

export function apiUrl(path){
  return API_BASE ? API_BASE + path : path;
}

/** لتغيير عنوان الخادم من وحدة التحكم أثناء التطوير. */
export function setApiBase(url){
  try {
    if (url) localStorage.setItem('fw.apiBase', url);
    else localStorage.removeItem('fw.apiBase');
    location.reload();
  } catch (err){ console.warn('تعذّر حفظ عنوان الـAPI:', err); }
}
